import * as R from 'ramda';
import { VPCTypeCode } from '../types';
import { fetchDEXFProductsForItemList } from './dexf';
import { getFamilyPrice, getRegularPrice } from './prices';
export const findMissingArticles = (articles, entities, allProducts) => {
    const getArticles = R.pipe(R.map(R.prop('ref')), R.filter(id => id !== 'room' && id !== ''));
    // New sliding doors have id with _V2 but it should still be possible to open old configurations
    const articlesInMarket = [
        ...articles,
        ...articles.filter(a => a.includes('_V2')).map(a => a.replace('_V2', ''))
    ];
    //Old sliding door models includes a part that includes PAX_P01 in id. This is no longer used and can be filtered out
    const articleIdsInConfiguration = getArticles(entities).filter(a => !a.includes('PAX_P01'));
    const productsInConfiguration = articleIdsInConfiguration.map(a => allProducts.find(p => p.coreProductId === a));
    const complimentaryItems = productsInConfiguration
        .flatMap(p => p?.parts?.filter(part => part.complimentary))
        .filter(Boolean)
        .map(item => item?.id.replace('ART-', ''));
    complimentaryItems.forEach(item => articleIdsInConfiguration.splice(articleIdsInConfiguration.indexOf(item), 1));
    const intersec = R.intersection(R.uniq(articleIdsInConfiguration), articlesInMarket);
    return articleIdsInConfiguration.filter(articleId => !intersec.includes(articleId));
};
export const getShoppingListFromDexf = async (vpcCode, dexfApiKey, itemListEndpoint) => {
    const dexfConfigurationResponse = await fetch(`${itemListEndpoint}${vpcCode}`, {
        headers: {
            'DEXF-API-KEY': dexfApiKey
        }
    })
        .then(response => {
        if (response.status !== 200) {
            // eslint-disable-next-line no-console
            console.error('Failed to fetch shoppinglist');
        }
        return response.json();
    })
        .then((json) => {
        return json.itemList.item;
    });
    return dexfConfigurationResponse;
};
function readFileAsync(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve(reader.result);
        };
        reader.readAsDataURL(blob);
        reader.onerror = reject;
    });
}
export const getVpcImage = async (response) => {
    const mainImage = response.imageUrl?.find((img) => img.typeCode === VPCTypeCode.MAIN_DESIGN_IMAGE);
    if (!mainImage || !mainImage?.url)
        return null;
    const res = await fetch(mainImage.url, { mode: 'no-cors' });
    const blob = await res.blob();
    const image = await readFileAsync(blob);
    return image;
};
export const getLegacyShoppingItems = (items, dexfArticles) => {
    return items.map(item => {
        const dexfArticle = dexfArticles.find(art => art.content?.ruItemNo === item.itemNo);
        const price = getFamilyPrice(dexfArticle) || getRegularPrice(dexfArticle);
        return {
            id: item.itemNo,
            type: item.itemType,
            quantity: item.quantity,
            price
        };
    });
};
export const getLegacyPlannerConfiguration = async (response, dexfApiKey, itemListEndpoint, settings, onLoadLegacyShoppingItems) => {
    const { configurationId } = response;
    const shoppingList = await getShoppingListFromDexf(configurationId, dexfApiKey, itemListEndpoint);
    const shoppingIds = shoppingList.map((item) => `${item.itemType}-${item.itemNo}`);
    const dexfArticles = await fetchDEXFProductsForItemList(settings, shoppingIds);
    if (shoppingIds.length > dexfArticles.filter(art => art.valid).length) {
        return null;
    }
    const legacyShoppingItems = getLegacyShoppingItems(shoppingList, dexfArticles);
    onLoadLegacyShoppingItems(legacyShoppingItems);
    const image = await getVpcImage(response);
    return {
        ...response,
        image
    };
};
//# sourceMappingURL=vpc.js.map